module.exports = require("portal-vue");